<div class="event-info-wrapper" [formGroup]="postInfoGroup">
  <div class="event-info-row">
    <div class="event-info-title">Call to Action&#x2a;</div>
    <div class="event-info-input">
      <p-dropdown
        [options]="ctaOptions"
        appendTo="body"
        formControlName="addButton"
        [placeholder]="ctaOptionsLoading ? 'Loading...' : 'Select a CTA'"
        optionLabel="label"
        optionValue="value"
        [disabled]="ctaOptions.length === 0 || ctaOptionsLoading"
      ></p-dropdown>
    </div>
  </div>
  <!-- Event Start Date -->
<div *ngIf="!type || type == 'offer'" class="event-info-row">
  <div class="event-info-title">
    Start Date&#x2a;
  </div>
  <div class="event-info-input">
    <p-calendar
      formControlName="startDate"
      [showIcon]="true"
      appendTo="body"
      dateFormat="mm/dd/yy"
      placeholder="mm/dd/yy"
      [minDate]="minStartDate"
    ></p-calendar>
  </div>
</div>

<!-- Event End Date -->
<div *ngIf="!type || type == 'offer'" class="event-info-row">
  <div class="event-info-title">
   End Date&#x2a;
  </div>
  <div class="event-info-input">
    <p-calendar
      formControlName="endDate"
      [showIcon]="true"
      appendTo="body"
      dateFormat="mm/dd/yy"
      placeholder="mm/dd/yy"
      [minDate]="minEndDate"
    ></p-calendar>
  </div>
</div>

<!-- Warning when other locations have showcases at same dates -->
<div *ngIf="(!type || type == 'offer') && showSameDatesWarning" class="event-info-row event-info-warning">
  <span class="warning-text">Other locations have a showcase created at the same dates.</span>
</div>
</div>
